import { generatePath } from 'react-router-dom'
import { workflowWriteIsAllowed } from '../utils/authorization'

class RouteError extends Error {
    constructor(msg) {
        super('RouteError: ' + msg)
    }
}

export const routeConfig = [
    {
        path: '/workflow/create',
        title: 'Create a new workflow',
        component: './Workflow/CreateWorkflow',
        name: 'workflow-create',
        breadcrumbs: [
            { label: 'Workflow', linkName: 'workflow' },
            { label: 'Create a new workflow' },
        ],
        permissions: context => workflowWriteIsAllowed(context),
    },
    {
        path: '/workflow/import',
        title: 'Import a new workflow',
        component: './Workflow/ImportWorkflow',
        name: 'workflow-import',
        breadcrumbs: [
            { label: 'Workflow', linkName: 'workflow' },
            { label: 'Import a workflow' },
        ],
        permissions: context => workflowWriteIsAllowed(context),
    },
    {
        path: '/workflow/export',
        title: 'Export a new workflow',
        component: './Workflow/ExportWorkflow',
        name: 'workflow-export',
        breadcrumbs: [
            { label: 'Workflow', linkName: 'workflow' },
            { label: 'Export a workflow' },
        ],
        permissions: context => workflowWriteIsAllowed(context),
    },
    {
        path: '/workflow/edit/:id',
        title: 'Edit workflow',
        component: './Workflow/EditWorkflow',
        name: 'workflow-edit',
        breadcrumbs: [
            { label: 'Workflow', linkName: 'workflow' },
            { label: 'Edit workflow' },
        ],
        permissions: context => workflowWriteIsAllowed(context),
    },
    {
        path: '/workflow',
        title: 'Workflow',
        component: './Workflow/List',
        name: 'workflow',
        breadcrumbs: [{ label: 'Workflow' }],
        permissions: context => workflowWriteIsAllowed(context),
    },
    {
        path: '/comments',
        title: 'Comments test page',
        component: './Comments/CommentSection',
        name: 'comment-list',
        breadcrumbs: [{ label: 'Comments' }],
    },
    {
        path: '/delegations',
        title: 'Delegation rules',
        component: './Delegation/DelegationList',
        name: 'delegation-list',
        breadcrumbs: [{ label: 'Delegations' }],
    },
    {
        path: '/handlers',
        title: 'Handlers',
        component: './Handlers/List',
        name: 'handlers',
        breadcrumbs: [{ label: 'Handlers' }],
    },
    {
        path: '/logout',
        title: 'Logout',
        component: './Logout',
        name: 'logout',
        breadcrumbs: [{ label: 'Logout' }],
    },
    {
        path: '/',
        title: 'Dashboard',
        component: './Dashboard',
        name: 'homepage',
        breadcrumbs: [{ label: 'Dashboard' }],
    },
]

export const reverse = (name, params = {}, queryParams = {}) => {
    const routes = routeConfig.filter(route => route.name === name)
    if (routes.length === 0) {
        throw new RouteError(`No matches found in routeConfig for ${name}`)
    } else if (routes.length > 1) {
        throw new RouteError(
            `Multiple matches found in routeConfig for ${name}: ${routes
                .map(r => r.path)
                .join(', ')}`
        )
    }
    // this will raise a TypeError if params provided do not match the path
    const path = generatePath(routes[0].path, params)
    if (Object.entries(queryParams).length) {
        const searchParams = new URLSearchParams(queryParams)

        return `${path}?${searchParams.toString()}`
    }
    return path
}
